// Fotografía con manejo elegante cuando falta una imagen (sin sustitutos genéricos)
export default function Foto({ src, alt = "", className = "", testid }) {
  if (!src)
    return (
      <div
        className={`flex items-center justify-center bg-sand-deep text-[11px] font-semibold uppercase tracking-widest text-ink-mute ${className}`}
        data-testid={testid}
      >
        ·
      </div>
    );
  return <img src={src} alt={alt} loading="lazy" className={`object-cover ${className}`} data-testid={testid} />;
}